var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRrArrowSmallRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C17.9951 11.4739 17.7832 10.9709 17.41 10.6L13.12 6.30001C12.9326 6.11376 12.6792 6.00922 12.415 6.00922C12.1508 6.00922 11.8974 6.11376 11.71 6.30001C11.6163 6.39297 11.5419 6.50357 11.4911 6.62543C11.4403 6.74729 11.4142 6.878 11.4142 7.01001C11.4142 7.14202 11.4403 7.27272 11.4911 7.39458C11.5419 7.51644 11.6163 7.62704 11.71 7.72001L15 11H5C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071C4.48043 12.8946 4.73478 13 5 13H15L11.71 16.29C11.5217 16.477 11.4154 16.7311 11.4144 16.9965C11.4135 17.2618 11.518 17.5167 11.705 17.705C11.892 17.8933 12.1461 17.9996 12.4115 18.0006C12.6768 18.0015 12.9317 17.897 13.12 17.71L17.41 13.41C17.7856 13.0367 17.9978 12.5296 18 12Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrArrowSmallRight);
export default __webpack_public_path__ + "static/media/fi-rr-arrow-small-right.87e684aeb5eab929eb1e78ba8c54a1cf.svg";
export { ForwardRef as ReactComponent };